import { type Enum } from '@webapp/infrastructure/types/Enum'

export const GlobalSearchResultTypes = {
  ORDER_REQUEST: 'order-request',
  EXPENSE_REQUEST: 'expense-request',
  TRAVEL_REQUEST: 'travel-request',
  PURCHASE_ORDER: 'purchase-order',
  BILL: 'bill',
  PAYMENT: 'payment',
  CATALOG_ITEM: 'catalog-item',
  VENDOR: 'vendor',
  CONTRACT: 'contract',
} as const

export type GlobalSearchResultTypeEnum = Enum<typeof GlobalSearchResultTypes>

export const GLOBAL_SEARCH_RESULT_TYPE_ORDER: GlobalSearchResultTypeEnum[] = [
  GlobalSearchResultTypes.ORDER_REQUEST,
  GlobalSearchResultTypes.EXPENSE_REQUEST,
  GlobalSearchResultTypes.TRAVEL_REQUEST,
  GlobalSearchResultTypes.PURCHASE_ORDER,
  GlobalSearchResultTypes.BILL,
  GlobalSearchResultTypes.PAYMENT,
  GlobalSearchResultTypes.CATALOG_ITEM,
  GlobalSearchResultTypes.VENDOR,
  GlobalSearchResultTypes.CONTRACT,
]
